import { ServiceFetch } from '../service-fetch'

export default class QuotationListModel extends ServiceFetch {
    getQuotationListBy = (data) => this.authFetch({
        url: 'quotation-list/getQuotationListBy',
        method: 'POST',
        body: JSON.stringify(data),
    })
}